var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafetyCodeColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00205b;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #545859;\n      }\n\n      .cls-3 {\n        fill: #ed8b00;\n      }\n\n      .cls-4 {\n        fill: #d9d9d6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "For_Color_Icons",
    "data-name": "For Color Icons",
    className: "cls-4",
    width: 200,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Safety_Code",
    "data-name": "Safety Code"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m96.01,43.86v93.69l-51.83-9.97V44.53c0-4.93,4.44-8.7,9.29-7.87l42.53,7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m42.62,136.82l57.38,11.49,57.38-11.49c3.74-.75,6.4-4.01,6.4-7.82V43.06l6.4-1.27c4.93-1,9.54,2.77,9.54,7.8v91.4c0,3.81-2.69,7.08-6.4,7.82l-73.33,14.65-73.33-14.68c-3.71-.72-6.4-4.01-6.4-7.8V49.59c0-5.03,4.61-8.8,9.54-7.8l6.4,1.27v85.97c0,3.81,2.69,7.08,6.4,7.82v-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m103.99,43.86v93.69l51.83-9.97V44.53c0-4.93-4.44-8.7-9.29-7.87l-12.32,2.09v35.78l-7.26-6.26-7.26,6.26v-33.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "119.69 74.52 126.94 68.26 134.2 74.52 134.2 38.74 128.34 39.73 119.69 41.2 119.69 74.52"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyCodeColor);
export default __webpack_public_path__ + "static/media/SafetyCode_Color.ae7c6c8afd0b9789a2561703a42ab241.svg";
export { ForwardRef as ReactComponent };